import request from '@/utils/request'

/**
 * 根据条件查询艺人列表
 *
 * @see http://tapd.oa.com/tme_music_lib/markdown_wikis/view/#1020369272008907475@toc39
 * @param {Object} query
 * @returns {Array<Tag>}
 */
function find(query) {
  return request({
    noEmpty: true,
    url: 'singer/query_singer',
    method: 'post',
    data: query
  })
}

/**
 * 根据 ID 查找艺人详细信息
 *
 * @see
 * @param {Object} data
 */
function findById(data) {
  return request({
    url: 'query_singer_by_id',
    method: 'post',
    data: data
  })
}

/**
 *
 * @see
 * @param {object} query
 */
function searchActor(query, options = {}) {
  return request({
    url: 'singer/search_singer',
    method: 'post',
    data: query,
    ...options
  })
}

/**
 *
 * @see
 * @param {Object} data 艺人信息
 */
function save(data) {
  return request({
    url: 'singer/save_singer',
    method: 'post',
    data: data
  })
}

export default {
  find,
  findById,
  searchActor,
  save,
}
